import type { Permission, Role, Session } from '../types';
import { canonicalPermission, PERMISSIONS } from './permissions';

export function can(session: Session | undefined, permission: Permission): boolean {
  if (session?.roles?.includes('superadmin')) return true;
  const expected = canonicalPermission(permission);
  return Boolean(session?.permissions.some((granted) => canonicalPermission(granted) === expected));
}

export function canAll(session: Session | undefined, permissions: Permission[]): boolean {
  return permissions.every((permission) => can(session, permission));
}

export function primaryRole(session: Session): Role {
  return session.roles[0] ?? 'supervisor';
}

export function creatableRoles(session: Session): Role[] {
  if (!can(session, PERMISSIONS.ROLE_MANAGE)) return [];
  const role = primaryRole(session);
  if (role === 'superadmin') return ['admin', 'freelancer', 'qc', 'superadmin'];
  if (role === 'admin') return ['manager', 'supervisor'];
  if (role === 'freelancer') return ['manager'];
  return [];
}
